import { Typography } from '@chronosphereio/chrono-ui';
import { TitleComponentOption } from 'echarts';
import { getNoDataMessage, useChartsTheme } from '@/components';

/**
 * Component for rendering "No Data" use cases outside of ECharts. Useful for components that render
 * this information in HTML.
 */
export function NoData() {
  const chartsTheme = useChartsTheme();

  const noDataTextStyle = (chartsTheme.noDataOption.title as TitleComponentOption).textStyle;
  const noDataTextContent = getNoDataMessage(chartsTheme);

  return (
    <Typography
      style={
        {
          // Need to cast here beacuse not all of the properties are actually compatible with CSS, but it
          // would be tedious to pick them out individually.
          ...noDataTextStyle,
        } as React.CSSProperties
      }
    >
      {noDataTextContent}
    </Typography>
  );
}
